<div class="card">
  <div class="card-header">
    <div class="d-flex">
      <div class="col-2 p-0">
        <div class="card-title d-flex align-items-center">
          Current Activity
          <waiting-dots
            *ngIf="loading"
            class="panel-loading-indicator"
            matTooltip="Refreshing"
            aria-label="Refreshing Current Activity"
          ></waiting-dots>
        </div>
      </div>
      <div class="col-10">
        <div class="d-flex flex-row flex-wrap">
          <div *ngFor="let item of formsAndReviewsFiltered">
            <span
              [matTooltip]="addMoreInfo(item.documents)"
              matTooltipClass="tooltip-blue"
              (click)="navigateToForm(item)"
              class="item"
              [ngClass]="{
                'item-dimmed': !item.documents?.length,
                'orange-background': item.order == 999
              }"
            >
              {{ item.code }}
              <span class="number"> {{ item.documents?.length }}</span>
            </span>
          </div>
        </div>
        <div class="d-flex flex-row flex-wrap mt-2">
          <div *ngFor="let item of checklistsFiltered">
            <span
              [matTooltip]="addMoreInfo(item.documents)"
              matTooltipClass="tooltip-blue"
              (click)="navigateToForm(item)"
              class="item"
              [ngClass]="{
              'item-dimmed': !item.documents?.length,
              'green-background':
                item.documents?.length &&
                (item.order ?? 0) > 4 &&
                (item.order ?? 0) < 999,
              }"
            >
              {{ item.code }}
              <span class="number"> {{ item.documents?.length }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
